import { flexRender, Row } from '@tanstack/react-table'
import clsx from 'clsx'

interface TableRowProps {
  index: number
  isMobile: boolean
  row: Row<any>
  rowsLength: number
  showModal: (row: Row<any>) => void
}

export function TableRow({ index, isMobile, row, rowsLength, showModal }: TableRowProps) {
  const visibleCells = row.getVisibleCells()
  return (
    <tr
      className={clsx('flex px-6', index < rowsLength - 1 && 'border-secondary border-b')}
      onClick={() => showModal(row)}
    >
      {visibleCells.map((cell, i) => {
        if (isMobile) {
          // Always hide the selection checkbox on mobile — show only the first data cell.
          if (cell.column.id === 'selection') return null
          const firstDataIndex = visibleCells[0]?.column.id === 'selection' ? 1 : 0
          if (i > firstDataIndex) return null
        }
        return (
          <td
            className="relative flex shrink-0 items-center overflow-hidden py-6 text-p-sm text-secondary justify-start"
            key={cell.id}
            style={{ flex: `${cell.column.getSize()} 0 0%` }}
          >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </td>
        )
      })}
    </tr>
  )
}
